export default __webpack_public_path__ + "assets/6597d6022c6eee7d87ce6e96d48a8793.woff";